import Unit from '@leverege/unit';
import { Plugins } from '@leverege/plugin';
import UnitAttributeCoordinateModel from "./coordinate/UnitAttributeCoordinateModel.js";
import AttributeCoordinateModel from "./coordinate/AttributeCoordinateModel.js";
import Util from "./Util.js";
import { AttributeCoordinateEditor, UnitAttributeCoordinateEditor } from "../editors/index.js";
function createUnitSpecificObjects() {
  const types = Unit.getUnitTypes();
  types.forEach(type => {
    // const key = `${type[0].toUpperCase()}${type.substring( 1 )}`
    const detailType = Util.getCoordinateTypeForType(type);
    const model = UnitAttributeCoordinateModel.createFor(type);
    const editor = UnitAttributeCoordinateEditor;

    // Not super happy with plugin registration here, but it can 
    // be overwritten if necessary
    Plugins.add('Model', {
      type: detailType,
      model
    });
    Plugins.add('ModelEditor', {
      type: detailType,
      editor
    });
  });
}
export default {
  install() {
    createUnitSpecificObjects();

    // Add base plugin
    Plugins.add('Model', {
      type: AttributeCoordinateModel.TYPE,
      model: AttributeCoordinateModel
    });
    Plugins.add('ModelEditor', {
      type: AttributeCoordinateModel.TYPE,
      editor: AttributeCoordinateEditor
    });

    // Add string plugin, Note: the string attribute is pretty much the default/generic attribute detail model
    const strType = Util.getCoordinateTypeForType('string');
    Plugins.add('Model', {
      type: strType,
      model: AttributeCoordinateModel.createFor(strType)
    });
    Plugins.add('ModelEditor', {
      type: strType,
      editor: AttributeCoordinateEditor
    });
  }
};